import createPassword from './createPassword';
import resetPassword from './resetPassword';

export default {
	createPassword,
	resetPassword,
	meta: {
		title: 'Connexion',
		description: 'Connexion'
	},
	title: 'Connexion à votre compte',
	description: 'Bienvenue sur votre plateforme Innovation !<br>Afin d’avoir accès à votre tableau de bord, veuillez vous connecter',
	passwordForgotten: 'J’ai oublié mon mot de passe',
	loginBtn: 'Me Connecter'
};
